export default "__VITE_PUBLIC_ASSET__1991dfe8__"